import * as React from 'react';

function StatusDot(props) {
  const { color = '#FFFFFF', size = 'm' } = props;
  const sizeMap = {
    s: {
      svg: '6',
      rect: '4',
      rx: '2',
    },
    m: {
      svg: '12',
      rect: '10',
      rx: '5',
    },
    l: {
      svg: '16',
      rect: '14',
      rx: '7',
    },
  };
  return (
    <svg
      width={sizeMap[size].svg}
      height={sizeMap[size].svg}
      viewBox={`0 0 ${sizeMap[size].svg} ${sizeMap[size].svg}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width={sizeMap[size].rect}
        height={sizeMap[size].rect}
        rx={sizeMap[size].rx}
        fill={color}
      />
    </svg>
  );
}

export default StatusDot;
